import { EMPTY_CELL } from './escape-html';

/**
 * A money column where having no amount is a normal answer.
 *
 * TAKES `unknown` ON PURPOSE, like the other custom formatters. A nullable decimal (a
 * charge type with no default price) is omitted from the API payload entirely, so the
 * CRUD hands this THE WHOLE ROW OBJECT rather than a value - anything that is not a
 * numeric string or number is "nothing to show".
 *
 * The value is a machine decimal, never user text, so it does not go through escapeHtml.
 */
export function money(value: unknown): string {
    const num = typeof value === 'number' ? value : typeof value === 'string' ? Number(value) : NaN;
    if (!Number.isFinite(num)) {
        return EMPTY_CELL;
    }

    return '$' + num.toFixed(2);
}
